import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  titleKey: string;
  bodyKey: string;
}
export const LegalModal = ({
  isOpen,
  onClose,
  titleKey,
  bodyKey
}: LegalModalProps) => {
  const {
    t
  } = useLanguage();
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-429">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} onClick={onClose} className="fixed inset-0 z-[100] bg-navy/70 backdrop-blur-sm flex items-end sm:items-center justify-center p-4" data-id="element-430">
          <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 40,
        scale: 0.96
      }} transition={{
        duration: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }} onClick={e => e.stopPropagation()} className="bg-white rounded-3xl max-w-2xl w-full max-h-[85vh] overflow-hidden flex flex-col shadow-2xl" data-id="element-431">
            <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-432">
              <h3 className="text-2xl font-bold text-navy" data-id="element-433">{t(titleKey)}</h3>
              <button onClick={onClose} className="w-10 h-10 rounded-full bg-gray-50 hover:bg-gray-100 flex items-center justify-center transition-colors" aria-label={t('legal.close')} data-id="element-434">
                <X className="w-5 h-5 text-navy" data-id="element-435" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto" data-id="element-436">
              <p className="text-gray-600 leading-relaxed whitespace-pre-line" data-id="element-437">
                {t(bodyKey)}
              </p>
            </div>
            <div className="p-6 border-t border-gray-100 bg-gray-50" data-id="element-438">
              <button onClick={onClose} className="w-full bg-navy hover:bg-navy-light text-white font-bold py-3 px-6 rounded-full transition-colors uppercase tracking-wide text-sm" data-id="element-439">
                {t('legal.close')}
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
};